import availabilityMiddleware from '../../availabilityProduct/middleware';
import { voucherMiddleware } from "../../order/voucher/middleware";
import { orderInfoManhattanMiddleware } from "../../order/manhattan/transition/middleware";
import { pakMiddleware } from "../../pak/middleware";
import { productsMiddleware } from '../../product/productList/middleware';
import { pageShellMiddleware } from '../../pageShell/middleware';
import setScrollPositionToLocalStorageMiddleware from '../../scrolling/middleware';
import searchParamsMiddleware from '../../searchParams/middleware';
import languageMiddleware from '../../language/middleware';
import { productMiddleware } from '../../product/productOverview/middleware';
import { personalizedProductOverviewOrderMiddleware } from '../../order/personalized-product-overview/middleware';
import { additionalDevicesMiddleware } from '../../manhattan/products/additionalDevices/middleware';
import { singleProductMiddleware } from "../../manhattan/products/singleProduct/middleware";
import { bundleDataMiddleware } from "../../manhattan/bundleData/middleware";
import initMiddleware from '../../init/middleware';
import captchaMiddleware from '../../captcha/middleware';
import { storesMapMiddleware } from '../../storesMap/middleware';
import redirectionMiddleware from '../../redirection/middleware';
import { orderMiddleware } from '../../order/basic/middleware';
import { orderManhattanMiddleware } from "../../order/manhattan/middleware";
import { getManhattanMiddleware } from "../../manhattan/bundle/middleware";
import { transactionMiddleware } from "../../transaction/middleware";
import { getCampaignMiddleware } from "../../campaign/campaignList/middleware";
import { campaignOverviewMiddleware } from "../../campaign/campaignOverview/middleware";
import { campaignAcceptanceMiddleware } from "../../campaign/acceptance/middleware";
import { campaignDetailsMiddleware } from "../../campaign/details/middleware";
import { campaignSoftElectroMiddleware } from "../../campaign/softElectro/middleware";
import { compareProductsMiddleware } from "../../compareDevices/middleware";
import saveOrderToEmailMiddleware from "../../order/save-order-to-email/middleware";
import { verificationSmsMiddleware } from "../../order/verification-sms/middleware";
import { wishListMiddleware } from "../../wishList/middleware";
import { authMiddleware } from "../../auth/middleware";
import recentlyViewedProductsMiddleware from "../../product/productOverview/recentlyViewedProducts/middleware";
import { productInsuranceMiddleware } from "../../product/insurance/middleware";
import preBasketProductsMiddleware from "../../preBasket/middleware";
import contractMiddleware from "../../contract/manhattan/middleware";
import { campaignModeMiddleware } from "../../campaign/campaignMode/middleware";
import { gtmMiddleware } from '../../analytics/middleware';
import { productSuggestionsMiddleware } from '../../product/suggestions/middleware';
import { debugMiddleware } from "../../debug/middleware";

export const appMiddleware = [
  ...getManhattanMiddleware,
  ...getCampaignMiddleware,
  ...campaignAcceptanceMiddleware,
  ...campaignOverviewMiddleware,
  ...campaignDetailsMiddleware,
  ...campaignSoftElectroMiddleware,
  ...productsMiddleware,
  ...pageShellMiddleware,
  ...productMiddleware,
  ...storesMapMiddleware,
  ...additionalDevicesMiddleware,
  ...voucherMiddleware,
  ...orderMiddleware,
  ...bundleDataMiddleware,
  ...orderManhattanMiddleware,
  ...orderInfoManhattanMiddleware,
  ...pakMiddleware,
  ...compareProductsMiddleware,
  ...wishListMiddleware,
  ...authMiddleware,
  ...productInsuranceMiddleware,
  ...personalizedProductOverviewOrderMiddleware,
  ...campaignModeMiddleware,
  ...verificationSmsMiddleware,
  ...productSuggestionsMiddleware,
  singleProductMiddleware,
  initMiddleware,
  searchParamsMiddleware,
  languageMiddleware,
  captchaMiddleware,
  setScrollPositionToLocalStorageMiddleware,
  availabilityMiddleware,
  redirectionMiddleware,
  transactionMiddleware,
  saveOrderToEmailMiddleware,
  recentlyViewedProductsMiddleware,
  preBasketProductsMiddleware,
  contractMiddleware,
  gtmMiddleware,
  debugMiddleware
];
